export default __webpack_public_path__ + "static/Monday-aeaab051454d6655fd3b28979b0c5a30.png";